import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getUserConsumedContent,
  getUserDailySessions,
  getUserMonthlySessions,
  getUserDevices,
  getUserSubscriptionHistory,
} from './thunks';
import { UsersAnalyticsState } from './types';

export const name = 'userAnalytics';

const initialState: UsersAnalyticsState = {
  userDevices: [],
  userBadges: [],
  userMonthlySessions: [],
  userDailySessions: [],
  userAuthMethods: [],
  userConsumedContent: [],
  userSubscriptionHistory: null,
  userConsumedContentStatus: 'idle',
  userDevicesStatus: 'idle',
  userBadgesStatus: 'idle',
  userMonthlySessionsStatus: 'idle',
  userDailySessionsStatus: 'idle',
  userAuthMethodsStatus: 'idle',
  userSubscriptionHistoryStatus: 'idle',
};
export const getUserConsumedContentAsync = createAsyncThunk(
  name + '/getUserConsumedContent',
  getUserConsumedContent
);

export const getUserDailySessionsAsync = createAsyncThunk(
  name + '/getUserDailySessions',
  getUserDailySessions
);

export const getUserMonthlySessionsAsync = createAsyncThunk(
  name + '/getUserMonthlySessions',
  getUserMonthlySessions
);

export const getUserDevicesAsync = createAsyncThunk(
  name + '/getUserDevices',
  getUserDevices
);

export const getUserSubscriptionHistoryAsync = createAsyncThunk(
  name + '/getUserSubscriptionHistory',
  getUserSubscriptionHistory
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getUserConsumedContentAsync.pending, (state) => {
        state.userConsumedContentStatus = 'loading';
      })
      .addCase(getUserConsumedContentAsync.fulfilled, (state, action) => {
        state.userConsumedContentStatus = 'idle';
        state.userConsumedContent = action.payload;
      })
      .addCase(getUserConsumedContentAsync.rejected, (state) => {
        state.userConsumedContentStatus = 'failed';
      })

      .addCase(getUserDailySessionsAsync.pending, (state) => {
        state.userDailySessionsStatus = 'loading';
      })
      .addCase(getUserDailySessionsAsync.fulfilled, (state, action) => {
        state.userDailySessionsStatus = 'idle';
        state.userDailySessions = action.payload;
      })
      .addCase(getUserDailySessionsAsync.rejected, (state) => {
        state.userDailySessionsStatus = 'failed';
      })

      .addCase(getUserMonthlySessionsAsync.pending, (state) => {
        state.userMonthlySessionsStatus = 'loading';
      })
      .addCase(getUserMonthlySessionsAsync.fulfilled, (state, action) => {
        state.userMonthlySessionsStatus = 'idle';
        state.userMonthlySessions = action.payload;
      })
      .addCase(getUserMonthlySessionsAsync.rejected, (state) => {
        state.userMonthlySessionsStatus = 'failed';
      })

      .addCase(getUserDevicesAsync.pending, (state) => {
        state.userDevicesStatus = 'loading';
      })
      .addCase(getUserDevicesAsync.fulfilled, (state, action) => {
        state.userDevicesStatus = 'idle';
        state.userDevices = action.payload;
      })
      .addCase(getUserDevicesAsync.rejected, (state) => {
        state.userDevicesStatus = 'failed';
      })
      .addCase(getUserSubscriptionHistoryAsync.pending, (state) => {
        state.userSubscriptionHistoryStatus = 'loading';
      })
      .addCase(getUserSubscriptionHistoryAsync.fulfilled, (state, action) => {
        state.userSubscriptionHistoryStatus = 'idle';
        state.userSubscriptionHistory = action.payload;
      })
      .addCase(getUserSubscriptionHistoryAsync.rejected, (state) => {
        state.userSubscriptionHistoryStatus = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
